// extracted by mini-css-extract-plugin
export default {"container":"WelcomeDashboard_container__083GO","fadeUp":"WelcomeDashboard_fadeUp__og+3a"};